import { PermissionLevelType } from '@shared/enums/permission-level.enum';

export function getPermissionWarningMessage(permission: PermissionLevelType, manager: string, role: string): string {
  return `You don't have permission <strong>${permission}</strong>, please ask ${manager} to add it to your <strong>${role}</strong> role`;
}
